import React from "react";
import { Link } from "react-router-dom";
const heroImage = "/Images/services/oil-gas/consulting/consulting.webp";
import {
  Cpu,
  Leaf,
  FlaskConical,
  Settings2,
  Activity,
  Microscope,
  HardHat,
  Recycle,
  SearchCheck,
  ChartNoAxesCombined,
  Mail,
  ArrowRight,
} from "lucide-react";

const enfoque = [
  {
    number: "01",
    title: "Análisis Personalizado",
    subtitle: "Evaluación estratégica de cada operación",
    description:
      "Evaluamos cada operación para identificar oportunidades de mejora y desarrollar soluciones adaptadas a las condiciones, necesidades y objetivos específicos de cada proyecto.",
    icon: SearchCheck,
  },
  {
    number: "02",
    title: "Tecnología Aplicada",
    subtitle: "Herramientas avanzadas para mejorar el desempeño",
    description:
      "Incorporamos herramientas y tecnologías avanzadas para optimizar procesos, mejorar la precisión y aumentar la eficiencia operativa, buscando soluciones más ágiles y efectivas.",
    icon: Cpu,
  },
  {
    number: "03",
    title: "Sostenibilidad",
    subtitle: "Eficiencia y uso responsable de los recursos",
    description:
      "Optimizamos recursos y procesos para reducir impactos y promover operaciones más responsables y eficientes, integrando criterios de sostenibilidad en nuestras soluciones.",
    icon: Leaf,
  },
  {
    number: "04",
    title: "Resultados Medibles",
    subtitle: "Soluciones enfocadas en generar valor",
    description:
      "Enfocamos nuestras soluciones en mejorar el desempeño, reducir costos y generar resultados sostenibles que aporten valor real a las operaciones de nuestros clientes.",
    icon: ChartNoAxesCombined,
  },
];

const services = [
  {
    number: "01",
    title: "Diseño de Fluidos a la Medida",
    subtitle: "Soluciones adaptadas a cada operación",
    description:
      "Diseñamos sistemas de fluidos de perforación, completamiento e intervención considerando las características del yacimiento, el historial de los pozos y los objetivos operacionales de cada proyecto.",
    icon: FlaskConical,
  },
  {
    number: "02",
    title: "Optimización de Operaciones",
    subtitle: "Mayor eficiencia y reducción de costos",
    description:
      "Analizamos los procesos existentes para identificar oportunidades de mejora, reducir tiempos y optimizar costos, manteniendo los estándares de seguridad y la integridad del pozo.",
    icon: Settings2,
  },
  {
    number: "03",
    title: "Simulación y Modelado Avanzado",
    subtitle: "Análisis técnico antes de la ejecución",
    description:
      "Utilizamos herramientas especializadas para evaluar escenarios, anticipar comportamientos y optimizar parámetros operacionales antes de llevar las soluciones a campo.",
    icon: Activity,
  },
  {
    number: "04",
    title: "Pruebas de Laboratorio Especializadas",
    subtitle: "Decisiones respaldadas por datos",
    description:
      "Realizamos pruebas y evaluaciones especializadas para caracterizar fluidos, validar diseños y respaldar técnicamente las decisiones de cada proyecto.",
    icon: Microscope,
  },
  {
    number: "05",
    title: "Soporte Técnico en Campo",
    subtitle: "Acompañamiento durante la operación",
    description:
      "Nuestros profesionales brindan acompañamiento técnico durante la ejecución, realizando seguimiento y ajustes para asegurar que las soluciones implementadas respondan a los objetivos establecidos.",
    icon: HardHat,
  },
  {
    number: "06",
    title: "Gestión de Residuos y Sostenibilidad",
    subtitle: "Operaciones más eficientes y responsables",
    description:
      "Optimizamos el uso de recursos y apoyamos la gestión responsable de los residuos generados durante las operaciones, buscando reducir impactos y mejorar la eficiencia del proceso.",
    icon: Recycle,
  },
];

const Consulting = () => {
  return (
    <>
      {/* HERO */}
      <section className="overflow-hidden">
        <div
          className="
      relative
      h-[520px]
      sm:h-[500px]
      md:h-[560px]
      lg:h-[580px]
      xl:h-[600px]
    "
        >
          {/* IMAGEN */}
          <img
            src={heroImage}
            alt="Consultoría y Optimización"
            className="
        absolute
        inset-0
        w-full
        h-full
        object-cover
        object-[center_35%]
        sm:object-[center_35%]
        md:object-[center_30%]
        lg:object-[center_30%]
      "
          />

          {/* CAPA OSCURA */}
          <div className="absolute inset-0 bg-black/20" />

          {/* GRADIENTE */}
          <div
            className="
        absolute
        inset-0
        bg-gradient-to-r
        from-black/70
        via-black/40
        to-transparent
      "
          />

          {/* CONTENIDO */}
          <div className="absolute inset-0 flex items-center">
            <div
              className="
          w-full
          max-w-7xl
          mx-auto
          px-4
          sm:px-6
          lg:px-8
        "
            >
              <div
                className="
            max-w-3xl
            pt-10
            sm:pt-12
            md:pt-14
          "
              >
                {/* ETIQUETA */}
                <span
                  className="
              inline-flex
              items-center
              px-3
              py-1.5
              sm:px-4
              sm:py-2
              rounded-full
              bg-[#ee7d32]/20
              text-[#ee7d32]
              text-xs
              sm:text-sm
              font-semibold
              uppercase
              tracking-wider
            "
                >
                  Servicios
                </span>

                {/* TITULO */}
                <h1
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-4xl
              sm:text-5xl
              md:text-6xl
              lg:text-7xl
              font-bold
              text-white
              leading-[0.95]
              tracking-tight
            "
                >
                  Consultoría y
                  <br />
                  <span className="text-[#ee7d32]">Optimización</span>
                </h1>

                {/* FRASE PRINCIPAL */}
                <p
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-base
              sm:text-lg
              md:text-xl
              text-white/90
              leading-7
              md:leading-8
              max-w-2xl
            "
                >
                  Soluciones estratégicas para optimizar el desempeño y la
                  eficiencia de sus operaciones.
                </p>

                {/* DESCRIPCIÓN */}
                <p
                  className="
              mt-3
              sm:mt-4
              md:mt-5
              text-sm
              sm:text-base
              text-white/80
              leading-6
              sm:leading-7
              max-w-2xl
            "
                >
                  Analizamos cada operación para identificar oportunidades de
                  mejora, incorporar tecnología y desarrollar soluciones
                  adaptadas a las necesidades de cada proyecto.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONSULTORÍA Y OPTIMIZACIÓN */}
      <section className="relative py-16 md:py-24 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="relative">
              <div
                className="
            absolute
            -bottom-5
            -right-5
            w-24
            h-24
            rounded-full
            bg-[#ee7d32]/10
            z-0
          "
              />

              <div
                className="
            relative
            z-10
            overflow-hidden
            rounded-[38px]
            rounded-tr-[110px]
            rounded-bl-[110px]
            shadow-[0_20px_60px_rgba(0,0,0,0.10)]
          "
              >
                <img
                  src="/Images/services/oil-gas/consulting/consulting_002.webp"
                  alt="Consultoría y optimización especializada"
                  className="
              w-full
              h-[340px]
              sm:h-[430px]
              md:h-[520px]
              object-cover
              transition-transform
              duration-700
              hover:scale-105
            "
                />
              </div>
            </div>

            <div>
              <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

              <span
                className="
            text-xs
            sm:text-sm
            font-bold
            uppercase
            tracking-[0.16em]
            text-[#ee7d32]
          "
              >
                Consultoría y Optimización
              </span>

              <h2
                className="
            mt-5
            text-3xl
            sm:text-4xl
            md:text-5xl
            font-bold
            text-[#111]
            leading-tight
          "
              >
                Soluciones estratégicas para{" "}
                <span className="text-[#ee7d32]">maximizar el valor</span> de
                sus operaciones
              </h2>

              <p
                className="
            mt-6
            text-[#555]
            text-sm
            sm:text-base
            md:text-lg
            leading-7
            md:leading-8
            max-w-xl
          "
              >
                En Sierra Alta entendemos que cada pozo, campo y operación
                presenta desafíos únicos. Por eso, acompañamos a nuestros
                clientes en el análisis, diseño y optimización de estrategias
                orientadas a mejorar el desempeño y reducir costos.
              </p>

              <p
                className="
            mt-5
            text-[#555]
            text-sm
            sm:text-base
            md:text-lg
            leading-7
            md:leading-8
            max-w-xl
          "
              >
                Desarrollamos soluciones de ingeniería a la medida, basadas en
                datos, tecnología y experiencia técnica para responder a las
                necesidades específicas de cada proyecto.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <span
                  className="
              inline-flex
              items-center
              rounded-full
              bg-[#fff3eb]
              px-4
              py-2
              text-sm
              font-semibold
              text-[#ee7d32]
            "
                >
                  Soluciones a la medida
                </span>

                <span
                  className="
              inline-flex
              items-center
              rounded-full
              bg-[#fff3eb]
              px-4
              py-2
              text-sm
              font-semibold
              text-[#ee7d32]
            "
                >
                  Ingeniería especializada
                </span>

                <span
                  className="
              inline-flex
              items-center
              rounded-full
              bg-[#fff3eb]
              px-4
              py-2
              text-sm
              font-semibold
              text-[#ee7d32]
            "
                >
                  Optimización operativa
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NUESTRO ENFOQUE */}
      <section className="relative py-20 md:py-24 bg-[#f3f3f3] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-end">
            <div>
              <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

              <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1]">
                Nuestro <span className="text-[#ee7d32]">Enfoque</span>
              </h2>
            </div>
          </div>

          <div className="mt-16 border-t border-gray-200">
            {enfoque.map((item) => {
              const Icon = item.icon;

              return (
                <div
                  key={item.number}
                  className="
              group
              relative
              grid
              grid-cols-1
              md:grid-cols-[120px_1fr_80px]
              gap-6
              md:gap-10
              items-center
              py-8
              md:py-10
              border-b
              border-gray-200
              transition-all
              duration-500
              hover:px-4
              md:hover:px-6
            "
                >
                  <div
                    className="
                text-5xl
                sm:text-6xl
                md:text-7xl
                font-bold
                text-[#ee7d32]/20
                leading-none
                transition-all
                duration-500
                group-hover:text-[#ee7d32]
              "
                  >
                    {item.number}
                  </div>

                  <div>
                    <div className="flex items-center gap-4">
                      <div
                        className="
                    w-10
                    h-10
                    rounded-xl
                    bg-[#fff3eb]
                    flex
                    items-center
                    justify-center
                    shrink-0
                    transition-all
                    duration-500
                  "
                      >
                        <Icon
                          className="
    w-5
    h-5
    transition-colors
    duration-500
    stroke-[#ee7d32]
  "
                          strokeWidth={1.8}
                        />
                      </div>

                      <h3
                        className="
                    text-xl
                    sm:text-2xl
                    md:text-3xl
                    font-bold
                    text-[#111]
                    transition-colors
                    duration-300
                    group-hover:text-[#ee7d32]
                  "
                      >
                        {item.title}
                      </h3>
                    </div>

                    <p
                      className="
                  mt-4
                  max-w-3xl
                  text-sm
                  md:text-base
                  text-gray-600
                  leading-7
                "
                    >
                      {item.description}
                    </p>
                  </div>

                  <div
                    className="
                hidden
                md:flex
                w-12
                h-12
                rounded-full
                border
              "
                  >
                    <ArrowRight
                      className="
                  w-5
                  h-5
                  text-[#999]
                  transition-all
                  duration-500
                  group-hover:stroke-[#ee7d32]
                  group-hover:translate-x-1
                "
                      strokeWidth={1.8}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SERVICIOS DE CONSULTORÍA Y OPTIMIZACIÓN */}
      <section className="relative py-20 md:py-24 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1]">
              Servicios de{" "}
              <span className="text-[#ee7d32]">Consultoría y Optimización</span>
            </h2>

            <p className="mt-6 text-base sm:text-lg text-[#555] leading-8 max-w-2xl">
              Integramos ingeniería, tecnología y experiencia técnica para
              desarrollar soluciones especializadas que mejoran el desempeño,
              optimizan recursos y generan valor en cada operación.
            </p>
          </div>

          <div className="mt-20">
            {services.map((item, index) => {
              const Icon = item.icon;
              const isLast = index === services.length - 1;

              return (
                <div
                  key={item.number}
                  className="group relative grid grid-cols-1 md:grid-cols-[90px_1fr] gap-6 md:gap-10"
                >
                  {!isLast && (
                    <div
                      className="
                  absolute
                  left-[44px]
                  top-[88px]
                  bottom-0
                  w-px
                  bg-gradient-to-b
                  from-[#ee7d32]
                  via-[#ee7d32]/30
                  to-transparent
                  hidden
                  md:block
                "
                    />
                  )}

                  <div className="relative z-10">
                    <div
                      className="
                  w-[88px]
                  h-[88px]
                  rounded-full
                  bg-[#ee7d32]
                  flex
                  items-center
                  justify-center
                  shadow-[0_12px_35px_rgba(238,125,50,0.25)]
                  transition-all
                  duration-500
                  group-hover:scale-110
                  group-hover:shadow-[0_18px_45px_rgba(238,125,50,0.35)]
                "
                    >
                      <Icon
                        className="
                    w-9
                    h-9
                    transition-transform
                    duration-500
                    group-hover:scale-110
                  "
                        stroke="white"
                        strokeWidth={1.7}
                      />
                    </div>
                  </div>

                  <div
                    className={`
                relative
                pb-14
                md:pb-16
                ${
                  !isLast
                    ? "border-b border-gray-200 mb-12 md:border-0 md:mb-0"
                    : ""
                }
              `}
                  >
                    <div>
                      <span
                        className="
                    text-xs
                    font-bold
                    uppercase
                    tracking-[0.18em]
                    text-[#ee7d32]
                  "
                      >
                        Servicio {item.number}
                      </span>

                      <h3
                        className="
                    mt-2
                    text-2xl
                    sm:text-3xl
                    font-bold
                    text-[#111]
                    leading-tight
                    transition-colors
                    duration-300
                    group-hover:text-[#ee7d32]
                  "
                      >
                        {item.title}
                      </h3>

                      <p className="mt-2 text-sm font-semibold text-gray-500">
                        {item.subtitle}
                      </p>
                    </div>

                    <p
                      className="
                  mt-5
                  max-w-4xl
                  text-sm
                  md:text-base
                  text-gray-600
                  leading-7
                "
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* BENEFICIOS CLAVE */}
      <section className="relative py-16 md:py-24 bg-[#f3f3f3] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mb-12 md:mb-16">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <span
              className="
          text-xs
          sm:text-sm
          font-bold
          uppercase
          tracking-[0.16em]
          text-[#ee7d32]
        "
            >
              Beneficios clave
            </span>

            <h2
              className="
          mt-5
          text-3xl
          sm:text-4xl
          md:text-5xl
          font-bold
          text-[#111]
          leading-tight
        "
            >
              Soluciones que generan{" "}
              <span className="text-[#ee7d32]">valor en cada proyecto</span>
            </h2>

            <p
              className="
          mt-6
          text-[#555]
          text-sm
          sm:text-base
          md:text-lg
          leading-7
          md:leading-8
          max-w-3xl
        "
            >
              Nuestra experiencia técnica nos permite desarrollar estrategias
              orientadas a optimizar recursos, mejorar el desempeño operativo y
              proteger los activos de nuestros clientes.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="relative">
              <div
                className="
            absolute
            -top-5
            -left-5
            w-24
            h-24
            rounded-full
            bg-[#ee7d32]/10
            z-0
          "
              />

              <div
                className="
            absolute
            -bottom-5
            -right-5
            w-24
            h-24
            rounded-full
            bg-[#ee7d32]/10
            z-0
          "
              />

              <div
                className="
            relative
            z-10
            overflow-hidden
            rounded-[38px]
            rounded-tr-[110px]
            rounded-bl-[110px]
            shadow-[0_20px_60px_rgba(0,0,0,0.10)]
          "
              >
                <img
                  src="/Images/services/oil-gas/consulting/torre3.webp"
                  alt="Beneficios de la consultoría especializada en petróleo y gas"
                  className="
              w-full
              h-[340px]
              sm:h-[430px]
              md:h-[520px]
              object-cover
              transition-transform
              duration-700
              hover:scale-105
            "
                />

                <div
                  className="
              absolute
              inset-0
              bg-gradient-to-t
              from-black/60
              via-black/10
              to-transparent
            "
                />

                <div
                  className="
              absolute
              bottom-0
              left-0
              right-0
              p-7
              sm:p-9
            "
                >
                  <span
                    className="
                inline-flex
                items-center
                rounded-full
                bg-white/15
                backdrop-blur-md
                border
                border-white/20
                px-4
                py-2
                text-xs
                font-bold
                uppercase
                tracking-[0.14em]
                text-white
              "
                  >
                    Nuestro impacto
                  </span>

                  <h3
                    className="
                mt-4
                text-2xl
                sm:text-3xl
                font-bold
                leading-tight
                text-white
                max-w-md
              "
                  >
                    Ingeniería enfocada en resultados y eficiencia
                  </h3>
                </div>
              </div>
            </div>

            <div className="space-y-1">
              <div
                className="
            group
            flex
            items-start
            gap-4
            py-5
            border-b
            border-gray-300
            transition-all
            duration-300
            hover:border-[#ee7d32]
          "
              >
                <div
                  className="
              flex-shrink-0
              w-10
              h-10
              rounded-full
              bg-[#fff3eb]
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                >
                  <span
                    className="
                text-sm
                font-bold
                text-[#ee7d32]
                transition-colors
                duration-300
              "
                  >
                    01
                  </span>
                </div>

                <div>
                  <h3
                    className="
                text-base
                sm:text-lg
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#ee7d32]
              "
                  >
                    Reducción de costos operativos
                  </h3>

                  <p className="mt-1 text-sm text-[#666] leading-6">
                    Optimización de recursos y prevención de problemas que
                    pueden generar pérdidas e ineficiencias durante la
                    operación.
                  </p>
                </div>
              </div>

              <div
                className="
            group
            flex
            items-start
            gap-4
            py-5
            border-b
            border-gray-300
            transition-all
            duration-300
            hover:border-[#ee7d32]
          "
              >
                <div
                  className="
              flex-shrink-0
              w-10
              h-10
              rounded-full
              bg-[#fff3eb]
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                >
                  <span
                    className="
                text-sm
                font-bold
                text-[#ee7d32]
                transition-colors
                duration-300
              "
                  >
                    02
                  </span>
                </div>

                <div>
                  <h3
                    className="
                text-base
                sm:text-lg
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#ee7d32]
              "
                  >
                    Mejora de la productividad
                  </h3>

                  <p className="mt-1 text-sm text-[#666] leading-6">
                    Diseños y estrategias que contribuyen a mejorar los tiempos
                    de operación y maximizar la recuperación de hidrocarburos.
                  </p>
                </div>
              </div>

              <div
                className="
            group
            flex
            items-start
            gap-4
            py-5
            border-b
            border-gray-300
            transition-all
            duration-300
            hover:border-[#ee7d32]
          "
              >
                <div
                  className="
              flex-shrink-0
              w-10
              h-10
              rounded-full
              bg-[#fff3eb]
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                >
                  <span
                    className="
                text-sm
                font-bold
                text-[#ee7d32]
                transition-colors
                duration-300
              "
                  >
                    03
                  </span>
                </div>

                <div>
                  <h3
                    className="
                text-base
                sm:text-lg
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#ee7d32]
              "
                  >
                    Decisiones basadas en datos
                  </h3>

                  <p className="mt-1 text-sm text-[#666] leading-6">
                    Análisis respaldados por simulaciones, pruebas de
                    laboratorio y monitoreo para tomar decisiones con mayor
                    precisión.
                  </p>
                </div>
              </div>

              <div
                className="
            group
            flex
            items-start
            gap-4
            py-5
            border-b
            border-gray-300
            transition-all
            duration-300
            hover:border-[#ee7d32]
          "
              >
                <div
                  className="
              flex-shrink-0
              w-10
              h-10
              rounded-full
              bg-[#fff3eb]
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                >
                  <span
                    className="
                text-sm
                font-bold
                text-[#ee7d32]
                transition-colors
                duration-300
              "
                  >
                    04
                  </span>
                </div>

                <div>
                  <h3
                    className="
                text-base
                sm:text-lg
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#ee7d32]
              "
                  >
                    Minimización del daño a la formación
                  </h3>

                  <p className="mt-1 text-sm text-[#666] leading-6">
                    Protección del yacimiento mediante soluciones diseñadas para
                    preservar la productividad y el valor del activo.
                  </p>
                </div>
              </div>

              <div
                className="
            group
            flex
            items-start
            gap-4
            py-5
            transition-all
            duration-300
          "
              >
                <div
                  className="
              flex-shrink-0
              w-10
              h-10
              rounded-full
              bg-[#fff3eb]
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                >
                  <span
                    className="
                text-sm
                font-bold
                text-[#ee7d32]
                transition-colors
                duration-300
              "
                  >
                    05
                  </span>
                </div>

                <div>
                  <h3
                    className="
                text-base
                sm:text-lg
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#ee7d32]
              "
                  >
                    Soluciones sostenibles
                  </h3>

                  <p className="mt-1 text-sm text-[#666] leading-6">
                    Integración de criterios ambientales y de eficiencia
                    energética sin comprometer el desempeño de las operaciones.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA CONSULTORÍA Y OPTIMIZACIÓN */}
      <section className="relative py-10 md:py-12 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="
        group
        relative
        overflow-hidden
        rounded-[30px]
        border
        border-[#ececec]
        bg-white
        shadow-[0_12px_40px_rgba(0,0,0,0.05)]
        transition-all
        duration-300
        hover:shadow-[0_20px_60px_rgba(0,0,0,0.10)]
      "
          >
            <div
              className="
          absolute
          top-0
          left-0
          h-full
          w-1.5
          bg-gradient-to-b
          from-[#ee7d32]
          via-[#ee7d32]/50
          to-transparent
        "
            />

            <div
              className="
          flex
          flex-col
          lg:flex-row
          lg:items-center
          lg:justify-between
          gap-8
          px-6
          py-8
          md:px-10
          md:py-9
        "
            >
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div
                    className="
                absolute
                inset-0
                bg-[#ee7d32]/20
                blur-xl
                rounded-2xl
              "
                  />

                  <div
                    className="
                relative
                w-14
                h-14
                md:w-16
                md:h-16
                rounded-2xl
                flex
                items-center
                justify-center
              "
                  >
                    <Mail
                      size={40}
                      className="stroke-[#ee7d32]"
                      strokeWidth={1.8}
                    />
                  </div>
                </div>

                <div>
                  <span
                    className="
                inline-flex
                items-center
                rounded-full
                bg-[#ee7d32]/10
                border
                border-[#ee7d32]/20
                px-3
                py-1
                text-[11px]
                md:text-[12px]
                font-semibold
                uppercase
                tracking-widest
                text-[#ee7d32]
              "
                  >
                    Consultoría y Optimización
                  </span>

                  <h3
                    className="
                mt-3
                text-2xl
                sm:text-3xl
                font-bold
                text-[#111]
                leading-tight
              "
                  >
                    ¿Necesitas una Consultoría Especializada?
                  </h3>

                  <p
                    className="
                mt-3
                text-sm
                md:text-base
                leading-7
                text-[#6b7280]
                max-w-2xl
              "
                  >
                    Contáctanos para obtener soluciones a medida y mejorar la
                    eficiencia de tus operaciones.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=oilgas&service=Consultoría y optimización"
                  className="
              group/btn
              inline-flex
              w-full
              sm:w-auto
              items-center
              justify-center
              gap-3
              rounded-lg
              bg-[#ee7d32]
              px-6
              py-3.5
              md:px-7
              md:py-4
              text-sm
              font-semibold
              text-white
              transition-all
              duration-300
              hover:bg-[#e56f20]
              hover:shadow-lg
              hover:shadow-[#ee7d32]/20
            "
                >
                  Solicita una asesoría
                  <ArrowRight
                    size={18}
                    className="
                transition-transform
                duration-300
                group-hover/btn:translate-x-1
                stroke-white
              "
                    strokeWidth={2}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Consulting;
